<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <div class="center" fusePerfectScrollbar>

        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <div class="mat-display-1 my-0 my-sm-24 welcome-message">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'GENERAL_CONTAINER_REPORT' |translate}}</span>
            </div>

            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div>
                
            </div>

        </div>

        <div>
            <div class="content-card p-20">
                <mat-card style="padding: 0 !important;">
                    <div class="p-20 table-select-style" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-card-title class="custom-card-title" fxFlex="70">
                            <span *ngIf="selectByFilter=='special'">{{'GENERAL_CONTAINER_REPORT' | translate}} ({{_generalContainerReport.length>0?((_generalContainerReport[0].timeFilterType | timeFilterType) | translate):''}})</span>
                            <span *ngIf="selectByFilter!='special'">{{'GENERAL_CONTAINER_REPORT' | translate}} ({{((selectByFilter | timeFilterType) | translate)}})</span>
                        </mat-card-title>
                        <div fxLayout="column">
                            <span style="font-size: medium; font-weight: 600;">Tarih Filtresi</span>
                            <div>
                                <span style="font-size: small; font-weight: 300;">{{StartTime | date:"dd.MM.yyyy"}}</span> - 
                                <span style="font-size: small; font-weight: 300;">{{EndTime | date:"dd.MM.yyyy"}}</span>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutGap="5px" fxLayoutGap.gt-sm="10px">
                            <button mat-mini-fab [matMenuTriggerFor]="menuUnloadingFilter">
                                <mat-icon>tune</mat-icon>
                            </button>
                            <mat-menu #menuUnloadingFilter="matMenu">
                                <div *ngIf="rootCompanyId==1" mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'COMPANY'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="companyId">
                                            <mat-option *ngFor="let company of companies" (click)="refresh()"
                                                [value]="company.id">{{company.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'REGION'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="polygonId">
                                            <mat-option *ngFor="let polygon of polygons" (click)="refresh()"
                                                [value]="polygon.id">{{polygon.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div mat-menu-item style="height: 75px;"  (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'CHOOSE_DATE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectByFilter">
                                            <mat-option (click)="onTimeChangeClick('day')" value="day">
                                                {{'TODAY'|translate}}
                                            </mat-option>
                                            <!-- <mat-option (click)="onTimeChangeClick('week')" value="week">
                                                {{'THIS_WEEK'|translate}}
                                            </mat-option> -->
                                            <mat-option (click)="onTimeChangeClick('month')" value="month">
                                                {{'THIS_MONTH'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onTimeChangeClick('year')" value="year">
                                                {{'THIS_YEAR'|translate}}
                                            </mat-option>
                                            <mat-option [matMenuTriggerFor]="menu" value="special">
                                                {{'OTHER'|translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-menu #menu="matMenu">
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'START_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="startpicker" name="startpicker"
                                                    placeholder="{{'START_DATE'|translate}}" [(ngModel)]="StartTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #startpicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'END_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="endRatePicker" name="endRatePicker"
                                                    placeholder="{{'END_DATE'|translate}}" [(ngModel)]="EndTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="endRatePicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #endRatePicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item
                                            (click)="StartTime && EndTime ?onTimeChangeClick('special',StartTime,EndTime):$event.stopPropagation()">
                                            OK
                                        </div>
                                    </mat-menu>
                                </div>
                            </mat-menu>
                            <!-- <button mat-mini-fab (click)="onReportClick()">
                                <mat-icon>cloud_download</mat-icon>
                            </button> -->
                        </div>

                    </div>
                    <div class="p-20 pt-0" style="overflow: auto;" fusePerfectScrollbar>
                        <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px; min-width: 700px;" #table matSortActive="beforeDate"
                        matSortDirection="desc"
                            [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}">

                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalContainer">
                                    {{generalContainer.name!=null?generalContainer.name:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="type">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalContainer">
                                    {{generalContainer.type!=null?((generalContainer.type |uppercase)|translate):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="volume">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'VOLUME' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalContainer">
                                    {{generalContainer.volume!=null?generalContainer.volume:"---"}} m³
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalDay">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TOTAL_DAY_COUNT' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalContainer">
                                    {{generalContainer.totalDay!=null?generalContainer.totalDay:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="processedDay">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'PROCESSED_DAY_COUNT' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalContainer">
                                    {{generalContainer.processedDay!=null?generalContainer.processedDay:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="maxOccupancy">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'MAX_OCCUPANCY'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalContainer">
                                    {{generalContainer.maxOccupancy!=null?generalContainer.maxOccupancy:'---'}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalGarbageProduced">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TOTAL_GARBAGE_PRODUCED'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalContainer">
                                    {{generalContainer.totalGarbageProduced!=null?generalContainer.totalGarbageProduced:'---'}} 
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="productivity">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'PRODUCTIVITY'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalContainer">
                                    {{generalContainer.productivity!=null?generalContainer.productivity:"---"}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="transactionFrequency">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TRANSACTION_FREQUENCY'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalContainer">
                                    {{generalContainer.transactionFrequency!=null?generalContainer.transactionFrequency:"---"}}
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                            <mat-row *matRowDef="let generalContainer; columns: displayedColumns;" class="order" matRipple>
                            </mat-row>
                        </mat-table>

                        <mat-paginator style="min-width: 700px;" #paginator [length]="paginator.length" [pageSize]="10"
                            [pageSizeOptions]="[10, 50, 100]">
                        </mat-paginator>
                    </div>
                    <mat-progress-bar [fxShow]="tableLoading" style="border-radius: 10px;" mode="indeterminate">
                    </mat-progress-bar>
                </mat-card>

            </div>

            <div class="content-card p-20">
                <div class="w-100-p" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
                    <mat-card fxFlex>
                        <mat-card-title class="custom-card-title" >{{'Tasarruf' | translate}}</mat-card-title>
                        <div id="chartProductivity">
                            <apx-chart
                              [series]="chartOptionsProductivity.series"
                              [chart]="chartOptionsProductivity.chart"
                              [xaxis]="chartOptionsProductivity.xaxis"
                              [stroke]="chartOptionsProductivity.stroke"
                              [theme]="chartOptionsProductivity.theme"
                              [dataLabels]="chartOptionsProductivity.dataLabels"
                              [yaxis]="chartOptionsProductivity.yaxis"
                              [labels]="chartOptionsProductivity.labels"
                              [legend]="chartOptionsProductivity.legend"
                              [title]="chartOptionsProductivity.title"
                            ></apx-chart>
                          </div>
                    </mat-card>
                    
                    <mat-card fxFlex>
                        <mat-card-title class="custom-card-title" >{{'MAX_OCCUPANCY' | translate}}</mat-card-title>
                        <div id="chartMaxOccupancy">
                            <apx-chart
                              [series]="chartOptionsMaxOccupancy.series"
                              [chart]="chartOptionsMaxOccupancy.chart"
                              [xaxis]="chartOptionsMaxOccupancy.xaxis"
                              [stroke]="chartOptionsMaxOccupancy.stroke"
                              [theme]="chartOptionsMaxOccupancy.theme"
                              [dataLabels]="chartOptionsMaxOccupancy.dataLabels"
                              [yaxis]="chartOptionsMaxOccupancy.yaxis"
                              [labels]="chartOptionsMaxOccupancy.labels"
                              [legend]="chartOptionsMaxOccupancy.legend"
                              [title]="chartOptionsMaxOccupancy.title"
                            ></apx-chart>
                          </div>
                    </mat-card>
                </div>
            </div>
        </div>

    </div>
</div>